var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"feedback"},[_c('CardFeedback',{attrs:{"departmentId":_vm.depId,"doctorId":null,"type":"clinic"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }